export default __webpack_public_path__ + "static/insights-290e68fabd57bf742c45d5197dfebf83.webm";